/**
 * Error screen for u13 users trying to link their accounts
 * to Clever
 */
import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {semanticColor, spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body, HeadingMedium} from "@khanacademy/wonder-blocks-typography";

interface Props {
    nickname: string;
    ageMissing: boolean;
    onSignUpClick: () => void;
    /**
     * Optional identifier to use for the dialog title.
     *
     * Usefult for announcing the dialog to Screen Readers, as it will be used
     * as the `aria-labelledby` attribute of the dialog.
     */
    titleId?: string;
}

export default function U13ErrorStep({
    nickname,
    onSignUpClick,
    ageMissing,
    titleId,
}: Props) {
    return (
        <View>
            <Strut size={spacing.medium_16} />
            <HeadingMedium id={titleId}>
                {t`Hello, ` + nickname + "!"}
            </HeadingMedium>
            <Strut size={spacing.xLarge_32} />
            <Body style={styles.error}>
                {ageMissing
                    ? t`Oops! We were unable to verify your age, so you can't use your personal account to join this class. Try signing up with your school email instead.`
                    : t`Oops! Given your age, you can't use your personal account to join this class. Try signing up with your school email instead.`}
            </Body>
            <Strut size={spacing.large_24} />
            <Button kind="secondary" onClick={onSignUpClick}>
                {t`Sign up with your school email`}
            </Button>
        </View>
    );
}

const styles = StyleSheet.create({
    error: {
        color: semanticColor.core.foreground.critical.subtle,
    },
});
